import { render, staticRenderFns } from "./ContentNavLink.vue?vue&type=template&id=6bc15ec0&scoped=true&"
import script from "./ContentNavLink.vue?vue&type=script&lang=js&"
export * from "./ContentNavLink.vue?vue&type=script&lang=js&"
import style0 from "./ContentNavLink.vue?vue&type=style&index=0&id=6bc15ec0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc15ec0",
  null
  
)

export default component.exports